var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrap" },
    [
      _c("div", { staticClass: "table" }, [_vm._t("table")], 2),
      _vm._t("pagination")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }